import React from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';
import { useLocale } from '@adsk/bim360-matrix-react-helpers/es/locale';
import objectValues from '@adsk/bim360-matrix-react-helpers/es/objectValues';
import { ENVS, REGIONS } from '@adsk/bim360-matrix-react-helpers/es/consts';
import { ISSUES_ENV_CONFIG_KEYS, statusColorMapping } from './consts';
import getEnvConfig from './helpers/getEnvConfig';
import EntityBlock from '../../EntityBlock';

/**
 * A component rendering Issue entity block.
 * @param entity
 * @param env
 * @param region
 * @param projectId
 * @param rest
 * @returns {*}
 * @constructor
 */
const IssueEntityBlock = ({ entity, env, region, projectId, ...rest }) => {
  const { T } = useLocale(({ locale }) => new MDText(require(`./i18n/${locale}.json`)));
  const { id, status, title, displayId } = entity;
  const userFriendlyId = displayId ? `#${displayId}` : displayId;
  const deeplinkUrl = `${getEnvConfig(
    env,
    region,
    ISSUES_ENV_CONFIG_KEYS.DOCS_FE
  )}/projects/${projectId}/issues/${id}`;
  const statusColor = status ? statusColorMapping[status] : null;
  const statusTextKey = status ? status.toUpperCase() : null;
  const statusText = statusTextKey ? T.translate(statusTextKey) : null;
  return (
    <EntityBlock
      entityTypeName={T.translate('ISSUE')}
      title={title}
      userFriendlyId={userFriendlyId}
      deeplinkUrl={deeplinkUrl}
      statusColor={statusColor}
      statusText={statusText}
      {...rest}
    />
  );
};

IssueEntityBlock.propTypes = {
  /**
   * The issue entity we need to render.
   */
  entity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    displayId: PropTypes.number.isRequired
  }).isRequired,
  /**
   * The environment. One of `ENVS` values.
   */
  env: PropTypes.oneOf(objectValues(ENVS)).isRequired,
  /**
   * The region. One of `REGIONS` values.
   */
  region: PropTypes.oneOf(objectValues(REGIONS)).isRequired,
  /**
   * The project ID
   */
  projectId: PropTypes.string.isRequired
};

export default IssueEntityBlock;
